<template>
  <article class="user_view">
    <left-menu/>
    <section class="user_view__header">
      <div class="user_view__header--info"> 
        <div>
          <h1>Clientes</h1>
          <h4>Listado de clientes registrados</h4>
        </div>
      </div>
      <div class="user_view__header--sec1">
        <button  class="secondary_button" :class="{'click':isUpdate, 'active': !isUpdate}" @click="toUpdate" >ACTUALIZAR</button>
        <button v-if="getRol() == 'admin'" class="primary_button" @click="$router.push({ name: 'CreateClient' })" >CREAR</button>
      </div>
      <info-table :name="'clientes'" :columns="columns" :items.sync="clients" :actions="true" :paginator="true"/>

      <!-- <div class="info_table__foot">
              <div/>
              <div class="paginator">
                {{shownItemsFrom}} - {{shownItemsTo}} 
                <div class="paginator__numbers">
                  <div v-for="(page,i) in total_pages" @click="handlePageChange(i+1)" :key=i class="paginator__numbers--num" :class="{'active': currentPage==i+1}">
                    {{i+1}}
                  </div>
                  <div class="paginator__numbers--num" @click="handlePageChange(currentPage+1)">
                    >
                  </div>
                </div>
              </div>
      </div> -->

    </section>
  </article>
</template>

<script>
import Table from './../shared/Table';
export default {
  data(){
    return{
      columns:[
        {
          name: 'Nombre',
          sortable: true,
          clickable:true
        },
        {
          name: 'Ciudad',
          sortable: true,
        },
        {
          name: 'NIT',
          sortable: true,
        },
        {
          name: 'Puestos de trabajo',
          sortable: true,
        },

        {
          name: 'Programación mensual',
          sortable: true,
        },
        
        {
          name: 'Acciones',
          enabled: true,
        }
      ],

      mockedClients:[
        {
          
          name: 'Fusepong S.A.S',
          nit: '451236 20 069823 1',
          city:'Bogotá',
          
          devices:{
            number:2,
            company: 'Fusepong S.A.S',
            location: 'Piso 1 - Entrada 5 - Edificio de Gobernación de Neiva',
          }
          
        },
      ],
      clients:[],
      isUpdate:false,
      total_pages: 0,
      currentPage: 1,
      shownItemsFrom:0,
      shownItemsTo: 12,
      maxPage:12,
    }
  },
  components:{
      'info-table':Table, 
  },
  methods:{

    handlePageChange(value) {
      this.currentPage = value;
      this.toUpdate()
    },

    toUpdate(){
       this.isUpdate=true;  
       setTimeout(() => { this.isUpdate=false; }, 200);  
      const customActions={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
    };
    var card=JSON.parse(localStorage.getItem("user")).id_card; 
    this.$resource('company'+ '?page=' + this.currentPage,{},customActions).get({"id_card":card})
    .then(function(data){
      this.total_pages = data.body.total_pages
      this.clients=data.body;    
    });
       
    }
  },
  created(){
    this.toUpdate()
    // const customActions={
    //     get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
    // };
    // var card=JSON.parse(localStorage.getItem("user")).id_card;    
    // this.$resource('company',{},customActions).get({"id_card":card})
    // .then(function(data){
    //   this.clients=data.body; 
    //   //console.log(data.body[0].user);
    // });
  },

  
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Clients.vue